<app-sgke110d [isMordal]="true" [isEdit]="data.isEdit" [rcvmnyNotificationreportMno]="data.rcvmnyNotificationreportMno"
    [rcvmnyNotificationreportRrkno]="data.rcvmnyNotificationreportRrkno"
    [rcvmnyReconciliationresultMno]="data.rcvmnyReconciliationresultMno"
    [rcvmnyNotificationreportUpdatesequencenumber]="data.rcvmnyNotificationreportUpdatesequencenumber"
    [rcvmnyreconciliationResultUpdatesequencenumber]="data.rcvmnyreconciliationResultUpdatesequencenumber"
    (dialogCloseEmitter)="closeDialog($event)">
</app-sgke110d>